import { useTheme } from "@convertkit/editor"

/**
 * useThemeAndStyle combines the theme context for a given tag with inline
 * styles passed in as the second argument. Example:
 *
 * ```js
 * const styles = useThemeStyle("h1", { fontSize: 18 })
 *
 * console.log(styles) // { color: "#c0ff33", fontSize: 18 }
 * ```
 *
 * @param {string} tag - the tag name, such as `h1`
 * @param {object} style - an object for inline styles
 * @returns {object}
 */

export default function useThemeAndStyle(tag, styles = {}) {
  const theme = useTheme()

  if (!theme || !theme[tag]) return styles

  return { ...theme[tag], ...styles }
}
